"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_api_1 = require("../../runtime-api");
const api_1 = require("../../api");
const compiler_api_1 = require("../../compiler-api");
class DurationComparison {
    functions() {
        const functions = [
            comparisonFunc('lt'),
            comparisonFunc('lte'),
            comparisonFunc('gt'),
            comparisonFunc('gte'),
            comparisonFunc('eq'),
            comparisonFunc('neq')
        ];
        return functions;
        function comparisonFunc(name) {
            return compiler_api_1.moduleFunction(name, api_1.BooleanType, [api_1.param(api_1.DurationType), api_1.param(api_1.DurationType)]);
        }
    }
    implementations() {
        const implementations = [
            this.implementation(params => this.lt(params), 'lt'),
            this.implementation(params => this.lte(params), 'lte'),
            this.implementation(params => this.gt(params), 'gt'),
            this.implementation(params => this.gte(params), 'gte'),
            this.implementation(params => this.eq(params), 'eq'),
            this.implementation(params => this.neq(params), 'neq')
        ];
        return implementations;
    }
    implementation(func, name) {
        return runtime_api_1.moduleImplementation(name, func, api_1.param(api_1.DurationType), api_1.param(api_1.DurationType));
    }
    lt(params) {
        return this.exec(params, (left, right) => left < right);
    }
    lte(params) {
        return this.exec(params, (left, right) => left <= right);
    }
    gt(params) {
        return this.exec(params, (left, right) => left > right);
    }
    gte(params) {
        return this.exec(params, (left, right) => left >= right);
    }
    eq(params) {
        return this.exec(params, (left, right) => left === right);
    }
    neq(params) {
        return this.exec(params, (left, right) => left !== right);
    }
    exec(params, comparer) {
        const [left, right] = this.resolveDurations(params).map(x => api_1.durationAsSeconds(x));
        return this.booleanValue(comparer(left, right));
    }
    booleanValue(value) {
        return runtime_api_1.runtimeValue(value, api_1.BooleanType);
    }
    resolveDurations(params) {
        if (params.length !== 2) {
            console.error('Coding error: Invalid parameters passed.', params);
            throw new Error('Coding error: Invalid parameters passed.');
        }
        const left = params[0].value;
        const right = params[1].value;
        return [left, right];
    }
}
exports.DurationComparison = DurationComparison;
//# sourceMappingURL=duration-comparison.js.map